import { useRef } from 'react'
import { useOrganizationEditRouting } from './useOrganizationEditRouting'
import { useOrganizationEditAssets } from './useOrganizationEditAssets'
import { useOrganizationEditForm } from './useOrganizationEditForm'

export function useOrganizationEditPage() {
  const routing = useOrganizationEditRouting()
  const formRef = useRef<ReturnType<typeof useOrganizationEditForm> | null>(null)
  const assets = useOrganizationEditAssets({
    orgId: routing.orgId,
    isEdit: routing.isEdit,
    onAutoUpload: (filePayload) => formRef.current?.uploadSingleFile(filePayload) ?? Promise.resolve(),
  })
  const form = useOrganizationEditForm({
    orgId: routing.orgId,
    isEdit: routing.isEdit,
    navigate: routing.navigate,
    assets,
  })
  formRef.current = form

  return {
    ...routing,
    ...assets,
    ...form,
  }
}

export type OrganizationEditPageContext = ReturnType<typeof useOrganizationEditPage>
